export const GOOGLE_ANALYTICS_ADDONS_ID = 'google-analytics-addons';
